<template>
  <ul class="navbar-nav mb-2 mb-lg-0">
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-white" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        MENU
      </a>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
        <li><a class="dropdown-item pointer" @click="router.push({ path: '/'})">Home</a></li>
        <li class="dropdown-divider"></li>
        <li><a class="dropdown-item pointer" @click="router.push({ name: 'mydepartment' })">My Department</a></li>
        <li class="dropdown-divider"></li>
        <li><a class="dropdown-item pointer" @click="router.push({ name: 'registrationapprovals' })">Registration Approvals</a></li>
        <li><a class="dropdown-item pointer" @click="router.push({ name: 'organizations' })">Registered Organizations</a></li>
        <li class="dropdown-divider"></li>
        <li><a class="dropdown-item pointer" @click="router.push({ name: 'programannualreports' })">Review Annual Reports</a></li>
        <li><a class="dropdown-item pointer" @click="router.push({ name: 'programHces' })">Review HCE Transactions</a></li>
        <li class="dropdown-divider"></li>
        <li><a class="dropdown-item pointer" @click="store.logout()">Sign Out</a></li>
      </ul>            
    </li>
  </ul>
</template>

<script setup>
import { useAuthStore } from '@/stores/authStore';
import { useRouter } from 'vue-router';

const store = useAuthStore();
const router = useRouter();


</script>
<style>
.pointer {
  cursor: pointer;
}
</style>

